// extracted by mini-css-extract-plugin
export var messageSideLeft = "_j5-1";
export var messageSideRight = "_j5-2";
export var subscribeToBackInStockBubbleContainer = "_j5-0";